import WaMessageIndex from "@/components/whatsapp/message_data/WaMessageIndex.vue";
import WaMessageAdd from "@/components/whatsapp/message_data/WaMessageAdd.vue";
import WaMessageDetail from "@/components/whatsapp/message_data/WaMessageDetail.vue";
import WaMessageEdit from "@/components/whatsapp/message_data/WaMessageEdit.vue";

let routesWaMessage= [
    {
        path: '',
        meta: {
          title: "List WA Message Data",
        },
        name: "WaMessageIndex",
        component: WaMessageIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create WA Message Data",
        },
        name: "WaMessageAdd",
        component: WaMessageAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail WA Message Data",
        },
        name: "WaMessageDetail",
        component: WaMessageDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit WA Message Data",
        },
        name: "WaMessageEdit",
        component: WaMessageEdit
    }
    
];

export default routesWaMessage
  